<template>
	<div class="home">
		<!-- 欢迎使用 -->
		<h2 class="qjc-texta-c">欢迎使用</h2>
		<div class="home-wrap">
			<div class="home-cell">
				<span>本次登录IP: {{userInfo.thisloginip}}</span> <span>本次登录时间: {{userInfo.thislogintime}}</span>
			</div>
			<div class="home-cell">
				<span>上次登录IP: {{userInfo.lastloginip}}</span> <span>上次登录时间: {{userInfo.lastlogintime}}</span>
			</div>
		</div>
		
		<div class="home-bottom">
			本后台系统由上海米因大数据科技开发团队 技术支持
		</div>
	</div>
</template>

<script>
	
	export default{
		name: 'home',
		data() {
			return {
				userInfo: {},
			}
		},
		mounted() {
			if(localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
		},
		methods: {
			
			
		},
	}
</script>

<style lang="scss" scoped>
	
	.home {
		padding: 30px 40px;
	}
	.home-wrap {
		padding: 40px;
		// border-bottom: 1px solid #dddddd;
	}
	.home-cell {
		font-size: 15px;
		margin-bottom: 10px;
		span {
			margin-right: 20px;
		}
	}
	.home-bottom {
		text-align: center;
		margin-top: 40px;
		font-size: 12px;
		padding-top: 20px;
		border-top: 1px solid #dddddd;
	}
	
	.charts_wrap {
		
	}
	.charts_title {
		font-size: 20px;
		color: #333;
	}
	.user_echarts {
		width: 100%;
		height: 450px;
		margin-bottom: 40px;
	}
	.order_echarts {
		width: 100%;
		height: 450px;
	}
</style>
